import axios from 'axios';
import config from '../config';

const domain = config.api_domain.domain

const GetEnvData = async (id, fuel, anualUse, volumen, scraping) => {
    try {
        const url = (`${domain}/environment/${id}/${fuel}/${anualUse}/${volumen}/${scraping}`)
        const res = await axios.get(url);
        return res.data.body;
    } catch (error) {
        console.error(error);
        return null;
    }
}

export default GetEnvData;